import { useEffect } from "react";

const BASE_URL = "https://www.rknolenlaw.org";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets unique per-page metadata: title, description, canonical, OG + Twitter.
 * Optionally injects a JSON-LD schema object.
 */
export function useSeo({ title, description, path = "/", image, schema }) {
  useEffect(() => {
    const url = `${BASE_URL}${path}`;
    const ogImage = image || `${BASE_URL}/og-image.png`;

    document.title = title;
    setMeta("name", "description", description);
    setLink("canonical", url);

    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "The Law Office of Ronald K. Nolen, LLC");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", ogImage);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);

    const SCHEMA_ID = "page-jsonld";
    const existing = document.getElementById(SCHEMA_ID);
    if (existing) existing.remove();
    if (schema) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = SCHEMA_ID;
      s.text = JSON.stringify(schema);
      document.head.appendChild(s);
    }
  }, [title, description, path, image, schema]);
}
